import { Button } from '@mui/material';
import { useCreateWindow } from 'features/windows/api/createWindow';
import { Wall } from 'types';
import { useCreateWall } from './api/createWall';

const ImportWallDialog = () => {
  const createWallMutation = useCreateWall({});
  const createWindowMutation = useCreateWindow({
    wallId: -1,
    config: { onSuccess: () => {} },
  });

  const handleImportClicked = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!e.target.files) return;
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target?.result;
      if (!text || typeof text !== 'string') return;
      const parsedWalls: Wall[] = JSON.parse(text);
      for (const wall of parsedWalls) {
        const { id, windows, user_id, ...wallCopy } = wall;
        const createdWall: any = await createWallMutation.mutateAsync({
          data: wallCopy,
        });
        if (!windows) continue;
        for (const window of windows) {
          const { id, ...windowCopy } = window;
          await createWindowMutation.mutateAsync({
            data: {
              ...windowCopy,
              wall_id: createdWall.data.id,
            },
          });
        }
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  return (
    <>
      <input
        style={{ display: 'none' }}
        id='import-license-button'
        type='file'
        accept='.txt'
        onChange={handleImportClicked}
      />
      <label htmlFor='import-license-button'>
        <Button color='primary' variant='contained' component='span'>
          Import
        </Button>
      </label>
    </>
  );
};

export default ImportWallDialog;
